<template>
  <div class="user-box">
    <div class="user-sidebar">
      <div class="user-sidebar-title">
        <img src="@/assets/icon_user_title.png">
        <span>欢迎参赛</span>
      </div>
      <div class="user-menu">
        <div class="user-li" @click="goInfo()">
          <img src="@/assets/icon_user_info_unselect.png">
          <span>个人信息</span>
        </div>
        <div class="user-li menu-activate">
          <img src="@/assets/icon_user_work_selected.png">
          <span>作品管理</span>
        </div>
        <div class="user-li" @click="goCert()">
          <img src="@/assets/icon_user_cert_unselect.png">
          <span>证书查询</span>
        </div>
      </div>
    </div>
    <div class="user-content">
      <div class="user-avatar-box">
        <div class="user-avatar">
          <label for="def_input">
            <img :src="avatar || require('@/assets/default_av.png')" alt=" ">
          </label>
          <input type="file" accept="image/*" hidden id="def_input" @change="getFile">
        </div>
        <span>{{ realname }}</span>
      </div>
      
      <div class="input-module-box">
        <template v-if="total > 0">
          <div class="works-list">
            <div class="table-line">
              <div class="table-cell table-cell-id">作品ID</div>
              <div class="table-cell table-cell-no">作品编号</div>
              <div class="table-cell table-cell-name">作品名称</div>
              <!--<div class="table-cell table-cell-race">赛道</div>-->
              <div class="table-cell table-cell-topic">类别</div>
              <div class="table-cell table-cell-state">状态</div>
              <div class="table-cell table-cell-operate">操作</div>
            </div>
            <template v-for="(item) in worksList">
              <div class="table-line table-content" :key="item.id">
                <div class="table-cell table-cell-content table-cell-id">{{item.id}}</div>
                <div class="table-cell table-cell-content table-cell-no">{{item.code}}</div>
                <div class="table-cell table-cell-content table-cell-name">{{item.title}}</div>
                <!--<div class="table-cell table-cell-content table-cell-race">{{item.raceStr}}</div>-->
                <div class="table-cell table-cell-content table-cell-topic">{{item.topicStr}}</div>
                <div class="table-cell table-cell-content table-cell-state">{{item.stateStr}}</div>
                <div class="table-cell table-cell-content table-cell-operate-item"> 
                  <span v-show="item.state == 1" @click="goEditInfo(item.id)">编辑</span>
                  <span v-show="item.state == 2" @click="goWorkInfo(item.id)">查看</span>
                  <span @click="delWorks(item.id)">删除</span>
                </div>
              </div>
            </template>
          </div>
          <div class="paging-box">
            <pagingEl :current-page="page" :total="total" :page-size="size" @currentChange="getUserWorksFn"/>
          </div>
        </template>
        <template v-else>
          <div class="works-list"></div>
        </template>
      </div>

      <div class="btn-work-upload" @click="goEdit()">
        <img src="@/assets/btn_user_work_upload.png"/>
      </div>
    </div>
  </div>
  
</template>

<script>
import pagingEl from "@/components/pagingEl";
import {Warning} from "@/plugins/warning";
import {getUserWorks,updateAv,getUserInfo,delUserWorks} from "@/request/api";
import $ from "jquery";
import OSS from "ali-oss";
export default {
  name: "works",
  components:{
    pagingEl
  },
  data() {
    return {
      avatar: '',
      realname: '', //用户名
      worksList: [],
      page: 0,
      size: 9,
      total: 0,
      checkWorksList: [],
    }
  },
  computed: {},
  created() {
    this.getUserInfo();
    this.getUserWorksFn()
  },
  inject: ['reload'],
  mounted() {
  },
  methods: {
    getUserInfo(){
      getUserInfo({}).then((res)=>{
        this.avatar = res.data.avatar;
        this.realname = res.data.realname;
      })
    },
    getUserWorksFn(e){
      const {page,size} = this;
      const curPage = e || page
      const requestData = {
        type: 'personal',
        page: curPage,
        size
      }
      getUserWorks(requestData).then(res=>{
        const resData = res.data
        this.worksList = resData.works;
        this.total = resData.paging.recordCount
        this.page = curPage
      })
    },
    goJoin(){
      this.$router.push({name:'userDesign'})
    },
    delWorks(id){
      this.$confirm("是否确认删除?", "提示", {
        iconClass: "el-icon-question", //自定义图标样式
        confirmButtonText: "确认", //确认按钮文字更换
        cancelButtonText: "取消", //取消按钮文字更换
        showClose: true, //是否显示右上角关闭按钮
        type: "warning", //提示类型  success/info/warning/error
      })
          .then(function () {
            delUserWorks({ids:[id]}).then(()=>{
              Warning.success('您的作品删除成功');
              setTimeout(()=>{
                location. reload();
              },2000)
            })
          })
          .then(() => {

          })
          .catch(function (err) {
            console.log(err);
          });
    },
    goInfo(){
      this.$router.push({name:'userAccountManage'})
    },
    goWork(){
      this.$router.push({name:'userWorks'})
    },
    goCert(){
      this.$router.push({name:'userCertificate'})
    },
    goEdit(){
      this.$router.push({name:'userWorksEdit'})
    },
    goEditInfo(id){
      this.$router.push({name:'userWorksEdit',query:{id}})
    },
    goWorkInfo(id){
      this.$router.push({name:'userWorksInfo',query:{id}})
    },
    getFile(e){
      const that = this;
      const file = e.target.value;
      let filename=file.replace(/.*(\/|\\)/, "");
      let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
      let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
      $.ajax({
        url: process.env.VUE_APP_SERVER_URL+'/works/uploads/index',
        data:{
          suffix:fileExt[0],
          path:"avatar"
        },
        headers:{
          Authorization:storage.infoModule.token
        },
        async: true,
        global: false,
        type: 'POST',
        dataType: 'json',
        timeout:1000*7,
        success: function(data) {
          if (data.status === 200) {
            const client = new OSS({
              region: data.result.data.region,
              accessKeyId: data.result.data.access_key_id,
              accessKeySecret: data.result.data.access_key_secret,
              stsToken: data.result.data.security_token,
              bucket: data.result.data.bucket,
            });

            client.multipartUpload(data.result.data.key, e.target.files[0], {
              // 设置上传回调。
              progress:(p) => {
                if(p>=1){
                  updateAv({avatar:data.result.data.url}).then(()=>{
                    that.$store.dispatch('infoModule/getUserInfo')
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000)
                  })
                }
              }
            });
          }else {
            Warning.open(data.msg);
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.user-box{
  width: 1280px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  padding-bottom: 100px;
  background: #F6F6F6;
  display: flex;
  .user-sidebar{
    width: 320px;
    height: 560px;
    background: #fff;
    //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .user-sidebar-title{
      width: 260px;
      height: 56px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 50px;
      img{
        width: 56px;
        height: 56px;
        float: left;
      }
      span{
        font-size: 24px;
        font-weight: 500 ;
        color: #FF3B30;
        height: 56px;
        line-height: 56px;
        float: left;
        margin-left: 20px;
      }
    }
    .user-menu{
      width: 260px;
      height: 340px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 50px;
      .user-li{
        float: left;
        width: 260px;
        height: 65px;
        margin-bottom: 30px;
        background-color: #FFF;
        cursor: pointer;
        img{
          width: 32px;
          height: 32px;
          float: left;
          margin-left: 25px;
          margin-top: 16px
        }
        span{
          font-size: 20px;
          font-weight: 400;
          color: #696969;
          height: 65px;
          line-height: 65px;
          float: left;
          margin-left: 20px;
        }
      }
      .menu-activate{
        background-color: #FF3B30;
        span{
          color: #FFF;
        }
      }
    }
  }
  .user-content{
    width: 930px;
    margin-left: 35px;
    background: #fff;
    //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .user-avatar-box{
      width: 95px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      .user-avatar{
        height: 95px;
        width: 95px;
        background: url(~@/assets/user_avatar_bg.png);
        background-size: cover;
        img{
          margin-top: 10px;
          margin-left: 10px;
          height: 72px;
          width: 72px;
          border-radius: 50%;
          overflow: hidden;
          cursor: pointer;
        }
      }
      span{
        font-size: 20px;
        font-weight: 400;
        color: #3F3F3F;
        height: 29px;
        line-height: 29px;
        text-align: center;
        display: block;
        margin-top: 10px;
      }
    }
    .btn-work-upload{
      width: 156px;
      height: 156px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 100px;
      margin-bottom: 100px;
      cursor: pointer;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .input-module-box{
      width: 800px;
      margin-left: auto;
      margin-right: auto;
      .works-list{
        width: 100%;
        .table-line{
          width: 100%;
          height: 50px;
          border-bottom: #ddd 1px solid;
          .table-cell{
            float: left;
            height: 50px;
            line-height: 50px;
          }
          .table-cell-id{
            width: 100px;
          }
          .table-cell-no{
            width: 150px;
          }
          .table-cell-name{
            width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .table-cell-race{
            width: 100px;
          }
          .table-cell-topic{
            width: 150px;
          }
          .table-cell-state{
            width: 50px;
            text-align: center;
          }
          .table-cell-operate{
            width: 100px;
            text-align: center;
          }
          .table-cell-operate-item{
            width: 100px;
            text-align: center;
            cursor: pointer;
            color: #FF3B30;
            span{
              margin-right: 10px;
            }
          }
        }
      }
    }
    .paging-box{
      margin-top: 50px;
      margin-bottom: 100px;
    }
  }
}
.paging-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 825px;
  //padding: 0 130px;
}
</style>
